<template>
  <RevModalBase
    background-color="low"
    class="rounded-lg relative mx-16 h-fit !w-fit md:mx-auto md:w-[384px]"
    has-padding
    :name="MODAL_NAMES.UPGRADE_FOR_LESS"
    :title="i18n(translations.title)"
    @close="handleUpgradeClose"
  >
    <template #body="{ close }">
      <div class="text-static-default-low body-1">
        {{ i18n(translations.description) }}
      </div>
      <UpgradeComparisonTable class="mt-24" :pickers />
      <RevButton
        class="mt-24"
        full-width="always"
        variant="primary"
        @click="handleUpgradeAccepted(close)"
      >
        {{ i18n(translations.upgradeAccept) }}
      </RevButton>
      <RevButton
        class="mt-8 block"
        full-width="always"
        variant="secondary"
        @click="handleUpgradeCancelled(close)"
      >
        {{ i18n(translations.upgradeCancel) }}
      </RevButton>
    </template>
  </RevModalBase>
</template>

<script setup lang="ts">
import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'
import { type CloseFn, RevModalBase } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '../../../../../../constants'
import UpgradeComparisonTable from '../UpgradeComparisonTable/UpgradeComparisonTable.vue'

import translations from './UpgradeModal.translations'

defineProps<{
  pickers: GetPickersResponse
}>()

const emit = defineEmits(['upgrade-accepted', 'upgrade-cancelled'])

const i18n = useI18n()
const { trackClick } = useTracking()

function handleUpgradeAccepted(close: CloseFn) {
  emit('upgrade-accepted')
  close()
  trackClick({
    zone: 'upgrade_for_less_modal',
    value: 'upgrade',
  })
}

function handleUpgradeCancelled(close: CloseFn) {
  emit('upgrade-cancelled')
  close()
  trackClick({
    zone: 'upgrade_for_less_modal',
    value: 'cancel',
  })
}

function handleUpgradeClose() {
  trackClick({
    zone: 'upgrade_for_less_modal',
    value: 'close',
  })
}
</script>
